export const buyCoin = async (symbol, amount, account) => {
  const token = localStorage.getItem("spectraToken") || "";
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/buy`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ symbol, amount, account }),
  });
  return res.json();
};

export const sellCoin = async (symbol, amount, account) => {
  const token = localStorage.getItem("spectraToken") || "";
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/sell`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ symbol, amount, account }),
  });
  return res.json();
};
